/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

var _ = require('lodash');

module.exports = function() {
    var utils = {
        /*
         * Gets arguments count same as in function definition not regarding to existence of particular arguments.
         * Do not include options in arguments count.
         */
        getAllArguments: function(functionArguments, argumentsCount) {
            var args = [];

            Array.prototype.push.apply(args, _.dropRight(functionArguments, 1));
            for (var i = 0; i < argumentsCount; i++) {
                if (!args[i]) {
                    args[i] = null;
                }
            }
            // argument options is always here
            args.push(_.last(functionArguments));
            return args;
        },

        /*
         * Returns renderable block or value in case of sub-expression invocation.
         */
        returnResult: function(options, context, value) {
            if (options.fn) {
                return value ? options.fn(context) : options.inverse(context);
            } else {
                return value;
            }
        },

        lastArgument: function(args) {
            var last = Array.prototype.slice.call(
                args,
                args.length - 1,
                args.length,
            );
            return last[0];
        },

        wrapHelper: function(fn) {
            return function() {
                var realArgs = Array.prototype.slice.call(arguments);
                var options = realArgs[realArgs.length - 1];
                if (
                    (_.isFunction(options.fn) &&
                        _.isFunction(options.inverse)) ||
                    _.isObject(options.hash)
                ) {
                    realArgs = realArgs.slice(0, arguments.length - 1);
                } else {
                    options = {};
                }
                _.extend(options, { args: realArgs });
                return fn.apply(this, [options].concat(realArgs));
            };
        },

        wrapHelpers: function(obj) {
            return _.fromPairs(
                _(obj)
                    .map(function(v, k) {
                        return [k, utils.wrapHelper(v)];
                    })
                    .value(),
            );
        },

        trimUrl: function(url, saveHash) {
            if (!_.isString(url)) {
                return '';
            }

            var hash = url.split('#')[1];
            var str = url.split('?')[0].replace(/(\.[a-z]+)*\.html$/, ''); // remove selector and html extension

            if (hash && saveHash) {
                str += '#' + hash;
            }

            return str.replace(/^\//, '');
        },
    };

    return utils;
};
